import React from 'react';

const VisWaarom = (props) => {

	const { currentStep } = props;

	const invissible  = {
		opacity: 0,
		transition: 'opacity 1s ease'
	};
	const vissible  = {
		opacity: 1,
    transition: 'opacity 1s ease'
	};

	const stylePublications = (currentStep < 6) ? invissible : vissible;

  return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 360">
		  <title>Waarom ramen we de koopkracht?</title>
		  <g id="opdrachtgevers" fill="#fff">
	      <polygon points="66 80 48 80 48 27.58 66 6 66 80" />
	      <path d="M111,39.87a.1.1,0,0,0-.1,0L99.09,42.7a.14.14,0,0,0-.09.13V79.88a.12.12,0,0,0,.11.12h11.78a.12.12,0,0,0,.11-.12V40A.13.13,0,0,0,111,39.87Z" />
	      <path d="M96,46s0,0,0,0l-6-16.3a.13.13,0,0,0-.23,0l-6,16.3s0,0,0,0H81.34s0,0,0,0l-6-16.3a.13.13,0,0,0-.23,0L69,46s0,0,0,0h0V80H96V46Z" />
	      <path d="M45,51l-1.92-6.27a.13.13,0,0,0-.24,0L40.9,51s0,0,0,0v6.49h-.55L27.1,41.5a.12.12,0,0,0-.19,0l-13.25,16h-.55V51s0,0,0,0l-1.93-6.27a.13.13,0,0,0-.24,0L9,51a.08.08,0,0,0,0,0V69.46H9V80H45V51A.08.08,0,0,0,45,51Z" />
		    <rect x="2" y="90" width="116" height="90" rx="3" fill="none" stroke="#fff" strokeWidth="1.2" />
		    <text transform="translate(8 107)" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, sans-serif" fontSize="13" fill="#fff" fontWeight="700">
		    <tspan>Kabinet</tspan>
		    <tspan x="0" y="16">Tweede Kamer</tspan>
		    <tspan x="0" y="32">Ministeries</tspan>
		    <tspan x="0" y="48">Vakbonden</tspan>
		    <tspan x="0" y="64">Werkgevers</tspan>
		    </text>
		    <g>
		      <line x1="133.73" y1="93.53" x2="143.03" y2="102.83" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="8.36"/>
		      <polygon points="150.8 92.65 132.86 110.6 150.8 110.6 150.8 92.65" fill="#fff"/>
		    </g>
		  </g>

		  <g id="cpb">
		    <rect x="132.5" y="123.48" width="215" height="150" fill="#e4b1ce"/>
		    <polygon points="288 126.48 192 126.48 210.69 105.48 269.31 105.48 288 126.48" fill="#fff"/>
		    <g>
		      <polygon points="179 274.48 179 139.81 172 139.81 172 122.69 212.63 122.69 240 95.1 267.37 122.69 308 122.69 308 139.81 301 139.81 301 274.48 179 274.48" fill="#fff"/>
		      <path d="M240,96.52l27,27.17h40v15.12h-7V273.48H180V138.81h-7V123.69h40l27-27.17m0-2.85-1.43,1.44-26.36,26.57H171v19.13h7V275.49H302V140.81h7V121.68H267.79L241.43,95.11,240,93.67Z" fill="#9d005d"/>
		    </g>
		    <rect x="203.88" y="158.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="147.88" y="158.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="232.5" y="158.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="261" y="158.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="203.88" y="194.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="147.88" y="194.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="316" y="158.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="316" y="194.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="232.5" y="194.1" width="15" height="24" fill="#9d005d"/>
		    <rect x="261" y="194.1" width="15" height="24" fill="#9d005d"/>
		    <path d="M252,245.1c-.16-8.65-5.45-15.6-12-15.6s-11.82,6.95-12,15.6h0v24h24v-24Z" fill="#9d005d"/>
		    <text transform="translate(240 143.37)" textAnchor="middle" fontSize="22" fill="#9d005d" fontFamily="Sans, RijksoverheidSansText-Bold, RijksoverheidSansText, Arial, sans-serif" fontWeight="700">CPB</text>
		  </g>

		  <g id="publicaties" style={stylePublications}>
		    <path d="M459.9,212.5v-5.4l8.1,8.1h-5.4A2.7,2.7,0,0,1,459.9,212.5Zm2.7,4.73H468V258.4a2.7,2.7,0,0,1-2.7,2.7H432.9a2.7,2.7,0,0,1-2.7-2.7V209.8a2.7,2.7,0,0,1,2.7-2.7h25v5.4A4.72,4.72,0,0,0,462.6,217.23Zm-1.69,29.36a1,1,0,0,0-1-1H438.3a1,1,0,0,0,0,2h21.6A1,1,0,0,0,460.91,246.59Zm0-8.1a1,1,0,0,0-1-1H438.3a1,1,0,0,0,0,2h21.6A1,1,0,0,0,460.91,238.49Zm0-8.1a1,1,0,0,0-1-1H438.3a1,1,0,0,0,0,2h21.6A1,1,0,0,0,460.91,230.39Zm0-8.1a1,1,0,0,0-1-1H438.3a1,1,0,0,0,0,2h21.6A1,1,0,0,0,460.91,222.29Z" fill="#fff"/>
		    <path d="M401.7,220.4V215l8.1,8.1h-5.4A2.7,2.7,0,0,1,401.7,220.4Zm2.7,4.72h5.4V266.3a2.7,2.7,0,0,1-2.7,2.7H374.7a2.7,2.7,0,0,1-2.7-2.7V217.7a2.7,2.7,0,0,1,2.7-2.7h25v5.4A4.72,4.72,0,0,0,404.4,225.12Zm-1.69,29.37a1,1,0,0,0-1-1H380.1a1,1,0,0,0,0,2h21.6A1,1,0,0,0,402.71,254.49Zm0-8.1a1,1,0,0,0-1-1H380.1a1,1,0,0,0,0,2h21.6A1,1,0,0,0,402.71,246.39Zm0-8.1a1,1,0,0,0-1-1H380.1a1,1,0,0,0,0,2h21.6A1,1,0,0,0,402.71,238.29Zm0-8.1a1,1,0,0,0-1-1H380.1a1,1,0,0,0,0,2h21.6A1,1,0,0,0,402.71,230.19Z" fill="#fff"/>
	      <path d="M434.15,258.37h-21.6a1,1,0,0,0,0,2h21.6a1,1,0,0,0,0-2Z" fill="#a90060"/>
	      <path d="M434.15,250.27h-21.6a1,1,0,0,0,0,2h21.6a1,1,0,0,0,0-2Z" fill="#a90060"/>
	      <path d="M434.15,266.47h-21.6a1,1,0,0,0,0,2h21.6a1,1,0,0,0,0-2Z" fill="#a90060"/>
	      <path d="M434.15,242.17h-21.6a1,1,0,0,0,0,2h21.6a1,1,0,0,0,0-2Z" fill="#a90060"/>
	      <path d="M434.15,233.4V228h-2v5.4a4.72,4.72,0,0,0,4.73,4.72h5.4v-2h-5.4A2.7,2.7,0,0,1,434.15,233.4Z" fill="#a90060"/>
	      <path d="M434.15,233.4a2.7,2.7,0,0,0,2.7,2.7h5.4l-8.1-8.1Z" fill="#fff"/>
	      <path d="M436.85,238.12a4.72,4.72,0,0,1-4.73-4.72V228h-25a2.7,2.7,0,0,0-2.7,2.7v48.6a2.7,2.7,0,0,0,2.7,2.7h32.4a2.7,2.7,0,0,0,2.7-2.7V238.12Zm-24.3,4h21.6a1,1,0,0,1,0,2h-21.6a1,1,0,0,1,0-2Zm0,8.1h21.6a1,1,0,0,1,0,2h-21.6a1,1,0,0,1,0-2Zm0,8.1h21.6a1,1,0,0,1,0,2h-21.6a1,1,0,0,1,0-2Zm0,8.1h21.6a1,1,0,0,1,0,2h-21.6a1,1,0,0,1,0-2Z" fill="#fff"/>
		    <rect x="361" y="293" width="118" height="60" rx="3" fill="none" stroke="#fff" strokeWidth="1.2" />
		    <text transform="translate(370 309)" fontWeight="700" fontSize="13" fill="#fff" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, Arial, sans-serif">
		    	<tspan>Publicaties</tspan>
		    	<tspan x="0" y="18">MEV, CEP, KIK, ...</tspan>
		    </text>
		    <g>
		      <line x1="328.81" y1="285.31" x2="338.83" y2="295.33" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="9"/>
		      <polygon points="347.19 284.37 327.87 303.69 347.19 303.69 347.19 284.37" fill="#fff"/>
		    </g>
		  </g>

		</svg>

  )
}


export default VisWaarom;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisWaarom.js